import React from 'react';
import { Flex, Box } from '@withjoy/joykit';
import { ReactComponent as LeftArrowSvg } from '@assets/icons/icon-left-arrow.svg';
import { ReactComponent as RightArrowSvg } from '@assets/icons/icon-right-arrow.svg';
import { StyledButton, Dot, DotsContainer, NAV_HEIGHT } from './Steps.styles';
import { MAX_HEIGHT } from '../../BottomSheetV2.styles';
import { StateObject, BottomSheetStateContext } from '../../BottomSheetV2.types';

type UsedContextValues<State = StateObject> = Pick<BottomSheetStateContext<State>, 'step' | 'setStep' | 'views' | 'maxHeight'>;

export function Steps<State = StateObject>({
  disableNavigation = false,
  step,
  setStep,
  views,
  maxHeight = MAX_HEIGHT,
}: { disableNavigation?: boolean } & UsedContextValues<State>) {
  const showNavComponent = views.length !== 1;

  const viewToShow = views.find(view => view.id === step);

  const currentIndex = viewToShow ? views.indexOf(viewToShow) : 0;

  const showLeftArrow = !!currentIndex;

  const showRightArrow = currentIndex !== views.length - 1;

  const handleLeftArrow = () => {
    // Assert user is not on the first step
    if (currentIndex > 0) {
      if (viewToShow?.backButtonDirection) {
        setStep(viewToShow.backButtonDirection);
        return;
      }

      setStep(() => {
        return views[currentIndex - 1].id;
      });
    }
  };

  const handleRightArrow = () => {
    // Assert user is not on the last step
    if (currentIndex < views.length - 1) {
      setStep(() => views[currentIndex + 1].id);
    }
  };

  return (
    <>
      <Box height={maxHeight - NAV_HEIGHT}>
        <>{viewToShow?.children}</>
      </Box>
      {showNavComponent && (
        <Flex
          alignItems="center"
          justifyContent="center"
          margin={6}
          height="48px"
          position="relative"
        >
          {showLeftArrow && (
            <StyledButton
              $side={'left'}
              onClick={handleLeftArrow}
              disabled={disableNavigation}
            >
              <LeftArrowSvg />
            </StyledButton>
          )}
          <DotsContainer
            alignItems="center"
            justifyContent="center"
          >
            {views.map((_, index) => (
              <Dot
                key={index}
                $isActive={index === currentIndex}
              />
            ))}
          </DotsContainer>
          {showRightArrow && (
            <StyledButton
              $side={'right'}
              onClick={handleRightArrow}
              disabled={disableNavigation || viewToShow?.disableNextButton}
            >
              <RightArrowSvg />
            </StyledButton>
          )}
        </Flex>
      )}
    </>
  );
}
